import { Box } from 'braid-design-system';
import type { FunctionComponent, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const StartOfContentTarget: FunctionComponent<Props> = ({
  children,
}) => (
  <Box tabIndex={-1} style={{ outline: 'none' }} id="start-of-content">
    {children}
  </Box>
);
